<template>
  <div v-if="section.id == 'proj3sect1'">
    <div v-if="isLeft(side)">
      <row-page-header>
        <span slot="title">IKEA Video Contest Entry</span>
        <span slot="category">Motion Deisgn, Narrative, Contest</span>
      </row-page-header>
      <div class="row">
        <div class="col-12">
          <p>
            2016 marked the 40th anniversary of IKEA in Canada. To celebrate the occaision, IKEA launched the Then &amp; Now Exhibit at the Design Exchange in Toronto.
          </p>
          <p>
            Coworkers were invited to submit a 90 second video for a chance to win an all expenses paid trip to Toronto to visit the exhibit and meet designers from IKEA of Sweden and members of Inter-IKEA.
          </p>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <row-vertical-center>
        <div class="row" :style="fakeContainerStyle()">
          <div class="col-6" v-for="(icons, index) in firstSectionIcons">
            <card :contents="icons"></card>
          </div>
        </div>
      </row-vertical-center>
    </div>
  </div>
  <div v-else-if="section.id == 'proj3sect2'">
    <row-vertical-center>
      <div class="row">
        <div class="col-12 text-center">
          <row-section-header>
            <span slot="title">
              Video Entry
            </span>
          </row-section-header>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2 text-center">
          <div class="d-block d-md-none">
            <iframe src="https://player.vimeo.com/video/181406728" width="100%" height="auto" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div>
          <div class="d-none d-md-block">
            <iframe src="https://player.vimeo.com/video/181406728" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </row-vertical-center>
  </div>
  <div v-else-if="section.id == 'proj3sect3'">
    <div v-if="isLeft(side)" class="mx-auto">
      <row-section-header>
        <span slot="title">
          Task
        </span>
      </row-section-header>
      <div class="row">
        <div class="col-12">
          <p>
            Coworkers were given 90 seconds or less to explain what makes working at IKEA great, as well as where the company will be in the next 40 years. Criteria was based on the submission's ability to answer these questions, and points were additionally given for motivation, creativity, and inspiration.
          </p>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row section-height py-5" :style="fakeContainerStyle()">
        TODO
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj3sect4'">
    <div v-if="isLeft(side)" class="mx-auto" width="100%">
      <row-section-header>
        <span slot="title">
          Approach
        </span>
      </row-section-header>
      <div class="row">
        <div class="col-12">
          <p>
            I began by creating a short script aimed toward answering the two main questions of the contest: why I love working at IKEA and where I see the company in the next 4 decades. I sketched out my idea before creating assets in Adobe Illustrator, in order to animate them in Adobe After Effects.I also used After Effects to edit the animation sequences together and add music and narration tracks.
          </p>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row">
        <div class="col-12 d-block d-md-none">
          <!-- for mobile START -->
          <div class="img-overflow y-hidden" style="margin-left: -15px; margin-right: -15px;">
            <img class="img w-100" src="@/../static/Script-Image.jpg" alt="script">
          </div>
          <!-- for mobile END -->
        </div>
        <div class="col-12 d-none d-md-block">
          <!-- for desktop START -->
          <row-vertical-center>
            <div class="img-overflow y-hidden x-hidden section-height" :style="affixComponentStyle(1)">
              <img class="img h-100 img-h-100" src="@/../static/Script-Image.jpg" alt="script">
            </div>
          </row-vertical-center>
          <!-- for desktop END -->
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <div class="p-5">
            <img class="img d-block w-100 h-auto mx-auto" src="@/../static/ikea_assets.png" alt="assets">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj3sect5'">
    <div v-if="isLeft(side)" class="mx-auto" width="100%">
      <row-section-header>
        <span slot="title">
          Outcome
        </span>
      </row-section-header>
      <div class="row">
        <div class="col-12">
          <p>
            After voting closed the animation was chosen as a winning entry, as well as garnered the largest amount of likes on the company's internal social media network. It was rewarding chatting with my peers about the opportunity, sharing what I learned on the trip toToronto, and of course meeting reknowned designers from IKEA of Sweden!
          </p>
        </div>
      </div>
    </div>
    <div v-if="isRight(side)">
      <div class="row">
        <div class="col-12 p-0">
          <img class="img section-height w-100" src="@/../static/screenshots.jpg" alt="screenshots">
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!-- for mobile START -->
          <div class="d-block d-md-none">
            <div class="img-overflow y-hidden" style="margin-left: -15px; margin-right: -15px;">
              <img class="img w-100" src="@/../static/democraticdesign.jpg" alt="democratic design">
            </div>
          </div>
          <!-- for mobile END -->
          <!-- for desktop START -->
          <div class="d-none d-md-block">
            <row-vertical-center>
              <div class="img-overflow y-hidden x-hidden section-height" :style="affixComponentStyle(1)">
                <img class="img w-100 img-h-100" src="@/../static/democraticdesign.jpg" alt="democratic design">
              </div>
            </row-vertical-center>
          </div>
          <!-- for desktop END -->
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="section.id == 'proj3sect6'">
    <div class="section-height">
      <div class="row">
        <div class="col-12 text-center">
          <row-section-header>
            <span slot="title">
              Video
            </span>
          </row-section-header>
        </div>
      </div>
      <div class="row pb-5">
        <div class="col-12 col-md-8 offset-md-2 text-center">
          <p class="px-5 pb-5">
            Though the video was created for an internal competition, it served as an excellent tool to create dialogue among my coworkers both in store and across the country. In addition, it was a great way to practice my animation skills in a short time frame by applying design and motion graphic concepts to a practical and rewarding challenge.
          </p>
          <div class="d-block d-md-none">
            <iframe src="https://player.vimeo.com/video/181406728" width="100%" height="auto" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div>
          <div class="d-none d-md-block">
            <iframe src="https://player.vimeo.com/video/181406728" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AffixedSectionBase from '@/components/AffixedSectionBase.js'
import RowPageHeader from '@/components/rows/PageHeader.vue'
import RowSectionHeader from '@/components/rows/SectionHeader.vue'
import RowColumnHeader from '@/components/rows/ColumnHeader.vue'
import RowVerticalCenter from '@/components/rows/VerticalCenter.vue'
import Card from '@/components/Card.vue'
import AsyncAnimation from '@/components/AsyncAnimation.vue'

export default {
  name: 'project-3-section-1',
  mixins: [AffixedSectionBase],
  components: {
    Card,
    RowPageHeader,
    RowSectionHeader,
    RowColumnHeader,
    RowVerticalCenter,
    AsyncAnimation,
  },
  data: function () {
    return {
      firstSectionIcons: [
        {
          name: {
            text: 'Company Contest',
            classes: ['little-small', 'strong'],
          },
          img: {
            path: '@/../static/ICONClient.svg',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: '40 Hours',
            classes: ['little-small', 'strong'],
          },
          img: {
            path: '@/../static/ICONTimeline.svg',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'Individual',
            classes: ['little-small', 'strong'],
          },
          img: {
            path: '@/../static/ICONTeam.svg',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'Video',
            classes: ['little-small', 'strong'],
          },
          img: {
            path: '@/../static/ICONProjectType.svg',
            classes: ['w-50', 'mx-auto']
          },
        },
      ],
      tasks: [
        {
          title: 'Find Clients',
          list: ['Our team worked with local improv company in Coquitlam, Second Storey Theatre'],
        },
        {
          title: 'Study & Apply Design Methods',
          list: [
            'Quick & Dirty Ethnography',
            'Participant Groups',
            'Ethnography Data Analysis',
            'Cultural Probes',
            'Informances',
            'Personas',
            'Participatory Workshops',
            'Concepts & Sketches',
            'Storyboards & Journey Maps',
          ]
        },
        {
          title: 'Final Concept',
          list: [
            'Low Fidelity UI',
            'Presentation Video',
          ]
        },
      ],
      roles: [
        {
          name: {
            text: 'The Director',
            classes: ['little-small', 'strong', 'serif', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/ImageIcon-director.png',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'The Players',
            classes: ['little-small', 'strong', 'serif', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/ImageIcon-players.png',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'The Techies',
            classes: ['little-small', 'strong', 'serif', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/ImageIcon-techies.png',
            classes: ['w-50', 'mx-auto']
          },
        },
        {
          name: {
            text: 'The Audience',
            classes: ['little-small', 'strong', 'serif', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/ImageIcon-Audience.png',
            classes: ['w-50', 'mx-auto']
          },
        },
      ],
      stakeholders: [
        {
          img: 'Icon-DIRECTOR-colour.svg',
          title: 'The Director',
          paragraphs: [
            "Owns and operates the Second Storey Theatre company in Coquitlam, BC",
            "Directs and MC’s shows, choosing what games are being played and eliciting instructions to the audience",
            "Works with actors during training sessions to help them grow and improve as performers",
          ],
        },
        {
          img: 'Icon-ACTORS-colour.svg',
          title: 'The Players',
          paragraphs: [
            "Work their way up from improv classes to becoming members of the regular performing group",
            "Under the direction of Graham, the company director, they meet weekly to practice their improv skills",
            "Always converge post-show to discuss the night’s show, work on improvements and critique each other’s performance",
          ],
        },
        {
          img: 'Icon-AUDIENCE-colour.svg',
          title: 'The Audience',
          paragraphs: [
            "Encouraged to engage when prompted (yelling suggestions, answers, participation games, etc.)",
            "Supports the theatre through ticket sales, concession sales, word of mouth advertising",
            "Potential to become part of the acting community by signing up with the Second Storey Improv group",
          ],
        },
        {
          img: 'Icon-TECHIE-colour.svg',
          title: 'The Techies',
          paragraphs: [
            "Made up of a small collection of members in the improv group, taking turns running the booth at shows",
            "Support the show by adding sound effects, lighting, and other technological help",
            "Need to have quick access to resources, such as sound bites and music, in order to effectively support audience suggestions and improv gestures",
          ],
        },
      ],
      usersWorld: [
        {
          name: {
            text: 'Cultural Probes',
            classes: ['little-small', 'serif', 'strong', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/Cultural-Probe-CLUSTER.png',
            classes: ['w-50', 'mx-auto']
          },
          desc: {
            text: "Seek out inspirational data with cultural probes (equipped with artifacts such as mood cards, madlibs, postcards) and given to different stakeholders in the company",
            classes: [],
          },
        },
        {
          name: {
            text: 'Participatory Workshops',
            classes: ['little-small', 'serif', 'strong', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/Participatory-Workshop-Cluster.png',
            classes: ['w-50', 'mx-auto']
          },
          desc: {
            text: "Seek out how stakeholders create and think about their craft through participatory exercises, such as collaging, sketching, and brainstorming",
            classes: [],
          },
        },
        {
          name: {
            text: 'Informances',
            classes: ['little-small', 'serif', 'strong', 'pt-2', 'pb-2'],
          },
          img: {
            path: '@/../static/informance-screenshot-square.jpg',
            classes: ['w-50', 'mx-auto']
          },
          desc: {
            text: "Explore potential painpoints and design solutions by roleplaying scenarios in informance videos.",
            classes: [],
          },
        },
      ],
      cardStrengthen: {
        name: {
          text: 'Strengthen',
          classes: ['serif', 'strong', 'pt-2', 'pb-2'],
        },
        img: {
          path: '@/../static/Icon-StrengthBLACK.png',
          classes: ['w-25', 'mx-auto']
        },
        desc: {
          text: "Actors already create personal goals and utilize feedback from their peers and directors. One goal was to help facilitate this process throughout all the channels of the Second Storey Theatre system.",
          classes: ['text-center'],
        },
      },
      cardMentor: {
        name: {
          text: 'Mentor',
          classes: ['serif', 'strong', 'pt-2', 'pb-2'],
        },
        img: {
          path: '@/../static/Icon-MentorBLACK.png',
          classes: ['w-25', 'mx-auto']
        },
        desc: {
          text: "Actors have a close relationship with the director who strives to bring out the best in all his players. The concept seeks to help the players access this mentorship beyond the limits of the theatre floor.",
          classes: ['text-center'],
        },
      },
      cardConnect: {
        name: {
          text: 'Connect',
          classes: ['serif', 'strong', 'pt-2', 'pb-2'],
        },
        img: {
          path: '@/../static/Icon-connectBLACK.png',
          classes: ['w-25', 'mx-auto']
        },
        desc: {
          text: "The Second Storey Theatre group plays to a comparatively small community but has the potential to grow. In order to grow the theatre we aimed to strengthen the theatre connecting the community together, increasing ways for the audience to interact with the theatre experience.",
          classes: ['text-center'],
        },
      },
      cardInform: {
        name: {
          text: 'Inform',
          classes: ['serif', 'strong', 'pt-2', 'pb-2'],
        },
        img: {
          path: '@/../static/Icon-informBLACK.png',
          classes: ['w-25', 'mx-auto']
        },
      }
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
.card-image-bigger>.card>img.w-50 {
  width: 80%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/sections/projects/project3/Section1.vue